<template>
    <div>
        书架
    </div>
</template>

<script>
    export default {
        name: "BookP"
    }
</script>

<style scoped>

</style>